<template>
  <div class="router-wrapper">
    <div class="os-tabs-w">
      <div class="os-tabs-controls os-tabs-complex">
        <div class="nav-item">
          <h1>{{ $t("characteristics_create.heading") }}</h1>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="element-box">
        <form>
          <div class="row" v-for="(key, index) in characteristic.keys" v-bind:key="index">
            <div class="col-sm-2">
              <label style="color: transparent">{{ $t("general.name") }}</label>

              <v-select
                :invalid="errors.has('lang_' + key.lang)"
                class="select"
                v-bind:name="'lang_' + key.lang"
                v-validate="'required'"
                v-model="key.lang"
                :options="availableLanguages.filter(al => !characteristic.keys.find(k => k.lang === al))"
                label="lang"
                v-bind:disabled="key.lang != null"
              />
            </div>
            <div class="col-sm-10">
              <div class="form-group">
                <label>{{ $t("general.name") }}</label>
                <div class="input-group">
                  <input
                    v-bind:name="'key_' + key.lang"
                    v-model="key.value"
                    v-validate="'required'"
                    style="border-top-right-radius: 4px; border-bottom-right-radius: 4px"
                    class="textfield"
                    :invalid="errors.has('key_' + key.lang)"
                    v-bind:placeholder="$t('general.name')"
                    type="text"
                  />
                  <div class="input-group-append">
                    <div class="input-group-text" style="background-color: transparent; border:none">
                      <button
                        type="button"
                        class="fab"
                        size="small"
                        color="primary"
                        v-on:click="addLanguage"
                        v-if="index === 0"
                      >
                        <i class="fas fa-plus"></i>
                      </button>

                      <button
                        type="button"
                        v-else
                        class="fab"
                        size="small"
                        color="error"
                        v-on:click="removeLanguage(index)"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>{{ $t("general.shortcut") }}</label>
                <input
                  :class="{ 'is-invalid': errors.has('shortcut') }"
                  name="shortcut"
                  v-model="characteristic.shortcut"
                  v-validate="'required'"
                  class="textfield"
                  v-bind:placeholder="$t('general.shortcut')"
                  type="text"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>{{ $t("general.unit") }}</label>
                <v-select
                  :invalid="errors.has('unit')"
                  class="select"
                  name="unit"
                  label="name"
                  v-validate="'required'"
                  v-model="characteristic.unit"
                  :options="units"
                  v-bind:placeholder="$t('general.unit')"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>{{ $t("general.category") }}</label>
                <v-select
                  :invalid="errors.has('category')"
                  class="select"
                  name="category"
                  v-validate="'required'"
                  v-model="characteristic.category"
                  :options="categories"
                  v-bind:placeholder="$t('general.category')"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>{{ $t("general.format") }}</label>
                <v-select
                  :invalid="errors.has('dataType')"
                  class="select"
                  name="dataType"
                  v-validate="'required'"
                  v-model="characteristic.dataType"
                  :options="dataTypes"
                  v-bind:placeholder="$t('general.format')"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 form-group">
              <checkbox
                :is-disabled="false"
                :is-selected="characteristic.isCritical"
                :on-click="() => (characteristic.isCritical = !characteristic.isCritical)"
                >{{ $t("characteristics.critical_characteristic") }}</checkbox
              >
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <button type="button" class="button" size="max" color="primary" v-on:click="send">
                {{ $t("general.save") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Characteristic from "@/models/Characteristic";
import languages from "@/languages";
import Checkbox from "@/components/core/controls/checkbox";

export default {
  name: "CharacteristicsCreate",
  components: {
    Checkbox
  },
  data() {
    return {
      characteristic: new Characteristic(),
      availableLanguages: languages.map(l => l.code)
    };
  },
  methods: {
    ...mapActions("characteristicsStore", ["fetch", "fetchCategories", "save", "fetchDataTypes"]),
    send() {
      this.$validator.validateAll().then(valid => {
        console.log(this.characteristic);
        if (valid) {
          this.characteristic.data_type = this.characteristic.dataType.id;
          this.characteristic.categoryId = this.characteristic.category.id;
          this.characteristic.characteristic_units_id = this.characteristic.unit.id;
          this.save(this.characteristic)
            .then(r => {
              if (r.data.addCharacteristic === "success") {
                this.$router.push("/characteristics");
              } else {
                alert(this.$i18n.t("characteristics_create.error_while_creating"));
              }
            })
            .catch(e => alert(e));
        }
      });
    },
    removeLanguage(index) {
      console.log(index);
      this.characteristic.keys.splice(index, 1);
    },
    addLanguage() {
      this.characteristic.keys.push({
        lang: null,
        value: null
      });
    }
  },
  mounted() {
    this.fetch();
    this.fetchCategories();
    this.fetchDataTypes();
  },
  computed: {
    ...mapState("characteristicsStore", ["categories", "units", "dataTypes"])
  }
};
</script>

<style scoped></style>
